<!-- =========================================================================================
  File Name: FormWizardValidation.vue
  Description: Form wizard with validation
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="vx-row">
      <!--<div class="vx-col w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3"></div>
      <div class="vx-col w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3"></div>-->
      <div class="vx-col w-full">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="DollarSignIcon"
          icon-right
          :statistic="value"
          statisticTitle="Total Geral"
          color="success"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { numberJS } from "@/helpers";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
export default {
  components: {
    StatisticsCardLine
  },
  computed: {},
  data() {
    return {
      value: {}
    };
  },
  methods: {
    getProducts(products) {
       this.value = numberJS().totalOrder(products)
     
    },
    
  },
  created() {
    this.value = 0;
  }
};
</script>
